export default [
  {
    title: '月份',
    key: 'month',
    fixed: true,
    width: 84
  },
  {
    title: '设计人员',
    key: 'designerName',
    fixed: true,
    width: 80
  },
  {
    title: '方案名称',
    key: 'programName',
    fixed: true,
    width: 80,
    overflow: true
  },
  {
    title: '角色-S',
    key: 'roleS',
    width: 60
  },
  {
    title: '角色-A',
    key: 'roleA',
    width: 60
  },
  {
    title: '角色-B',
    key: 'roleB',
    width: 60
  },
  {
    title: '角色-C',
    key: 'roleC',
    width: 60
  },
  {
    title: '道具-A',
    key: 'propsA',
    width: 60
  },
  {
    title: '道具-B',
    key: 'propsB',
    width: 60
  },
  {
    title: '道具-C',
    key: 'propsC',
    width: 60
  },
  {
    title: '地编-SS',
    key: 'mapSs',
    width: 70
  },
  {
    title: '地编-S',
    key: 'mapS',
    width: 60
  },
  {
    title: '地编-A',
    key: 'mapA',
    width: 60
  },
  {
    title: '地编-B',
    key: 'mapB',
    width: 60
  },
  {
    title: '地图-S',
    key: 'platS',
    width: 86
  },
  {
    title: '地图-A',
    key: 'platA',
    width: 86
  },
  {
    title: '地图-B',
    key: 'platB',
    width: 86
  },
  {
    title: '序列-C',
    key: 'orderC',
    width: 86
  },
  {
    title: '序列-D',
    key: 'orderD',
    width: 106
  },
  {
    title: 'Layout-A',
    key: 'layoutA',
    width: 106
  },
  {
    title: 'Layout-B',
    key: 'layoutB',
    width: 86
  },
  {
    title: '特效-A',
    key: 'specialA',
    width: 86
  },
  {
    title: '特效-B',
    key: 'specialB',
    width: 86
  },
  {
    title: '特效-C',
    key: 'specialC',
    width: 86
  },
  {
    title: '渲染-S',
    key: 'renderingS',
    width: 60
  },
  {
    title: '渲染-A',
    key: 'renderingA',
    width: 60
  },
  {
    title: '渲染-B',
    key: 'renderingB',
    width: 60
  },
  {
    title: '渲染-C',
    key: 'renderingC',
    width: 60
  },
  {
    title: '后期-A',
    key: 'lateA',
    width: 60
  },
  {
    title: '后期-B',
    key: 'lateB',
    width: 60
  },
  {
    title: '后期-C',
    key: 'lateC',
    width: 60
  },
  {
    title: '绑定-A',
    key: 'bindA',
    width: 60
  },
  {
    title: '绑定-B',
    key: 'bindB',
    width: 60
  },
  {
    title: '绑定-C',
    key: 'bindC',
    width: 86
  },
  {
    title: '绑定-D',
    key: 'bindD',
    width: 86
  },
  {
    title: '动画-A3',
    key: 'videoA3',
    width: 86
  },
  {
    title: '动画-A2',
    key: 'videoA2',
    width: 86
  },
  {
    title: '动画-A1',
    key: 'videoA1',
    width: 86
  },
  {
    title: '动画-B2',
    key: 'videoB2',
    width: 86
  },
  {
    title: '动画-B1',
    key: 'videoB1',
    width: 86
  },
  {
    title: '动画-C',
    key: 'videoC',
    width: 60
  },
  {
    title: '蓝图-S',
    key: 'blueprintS',
    width: 60
  },
  {
    title: '蓝图-A',
    key: 'blueprintA',
    width: 60
  },
  {
    title: '蓝图-B',
    key: 'blueprintB',
    width: 60
  },
  {
    title: '蓝图-C',
    key: 'blueprintC',
    width: 60
  },
  {
    title: '界面',
    key: 'panel',
    width: 66
  },
  {
    title: '动画界面',
    key: 'animationInterface',
    width: 66
  },
  {
    title: 'icon',
    key: 'icon',
    width: 66
  },
  {
    title: 'Loading',
    key: 'loading',
    width: 66
  },
  {
    title: 'UI',
    key: 'ui',
    width: 66
  },
  {
    title: '落地页',
    key: 'loadingPage',
    width: 66
  },
  {
    title: '五图',
    key: 'fiveFigure',
    width: 66
  },
  {
    title: 'Logo',
    key: 'logo',
    width: 66
  },
  {
    title: '平面投放',
    key: 'graphicLaunch',
    width: 86
  },
  {
    title: '场景原画-S',
    key: 'scenePaintingS',
    width: 86
  },
  {
    title: '场景原画-A',
    key: 'scenePaintingA',
    width: 86
  },
  {
    title: '角色原画-S',
    key: 'rolePaintingS',
    width: 86
  },
  {
    title: '角色原画-A',
    key: 'rolePaintingA',
    width: 86
  },
  {
    title: '角色原画-B',
    key: 'rolePaintingB',
    width: 86
  },
  {
    title: '道具/UI原画-A',
    key: 'propsPaintingA',
    width: 96
  },
  {
    title: '道具/UI原画-B',
    key: 'propsPaintingB',
    width: 96
  },
  {
    title: '道具/UI原画-C',
    key: 'propsPaintingC',
    width: 96
  },
  {
    title: '纯原创icon',
    key: 'originalIcon',
    width: 96
  },
  {
    title: '纯原创loading',
    key: 'originalLoading',
    width: 96
  },
  {
    title: '操作',
    key: 'control',
    fixed: true,
    width: 70
  }
]
